import React from 'react';
import PropTypes from 'prop-types';


import {useI18nMessage} from '../../../contexts/I18n';

import styles from './ContactUsLink.scss';


function ContactUsLink({message, subject}) {

    const contactUsMessage = useI18nMessage('contact.mail.link');

    return (
        <a
            aria-label={contactUsMessage}
            className={styles.contactUsLink}
            href={`mailto:contact@journexx.com?subject=${subject}`}
        >
            {message || contactUsMessage}
        </a>
    );
}


ContactUsLink.propTypes = {
    message: PropTypes.string,
    subject: PropTypes.string.isRequired
};

ContactUsLink.defaultProps = {
    subject: 'Contact Us'
};


export default ContactUsLink;
